import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToken } from "../components/useToken";
import { prepareLogData } from "../components/Util";
import { Dialog, TranslatedString } from "@bosch/bt-ui";
import CenterLoadingContainer from "../components/CenterLoadingContainer";

const LogoutPage = () => {
  const { token, deleteToken, isLoggedIn } = useToken();
  const navigate = useNavigate();

  useEffect(() => {
    const hasToken = typeof token.token === "string" && token.token.length > 0;

    if (hasToken) {
      const data = prepareLogData(token, "HomePage", "UserLogOut");
      fetch(MOBY_API_URL + "/api/activity/v1/activitylog", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token.token,
        },
        body: JSON.stringify(data),
      });
    }

    if (isLoggedIn()) {
      deleteToken();
    }
  }, [deleteToken, isLoggedIn, token, navigate]);

  return (
    <Dialog
      htmlAttributes={{
        className: "log-out-modal",
      }}
      focusTrapped={false}
      title={<TranslatedString stringId="dialog-info" />}
      // Can be either "error", "warning", "success", "info", or "none"
      alertType="info"
    >
      <h1 className="font-large">
        <TranslatedString stringId="logout-keycloak" />
      </h1>

      <CenterLoadingContainer />
    </Dialog>
  );
};

export default LogoutPage;
